import { loading } from './loading';
import { notificationQueue } from './notification-queue';
import { UNQIndexStyle } from './UNQ-index-style';

export const getUNQIndex = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  UNQIndex: {
    '@global':
      Object.assign(
        UNQIndexStyle(_, { palette, iconFontFamily }),
        notificationQueue(_, { palette, iconFontFamily }),
        loading(_, { palette, iconFontFamily })
      ),
  },
});
